const NoteText = ({ children }: React.PropsWithChildren) => (
  <div className="min-h-25 flex items-center">
    <p className="text-foreground text-[9px] leading-[1.6] text-center italic whitespace-pre-wrap w-full">{children}</p>
  </div>
);

export default NoteText;
